// JS
import '~/src/custom/js/index';

// Base SCSS
import '~/src/custom/scss/base.scss';
import '~/src/custom/scss/layout.scss';

// Components JS
import '~/src/custom/js/pagebuilder';

// Components SCSS
import '~/src/custom/scss/pagebuilder.scss';


//// import vue app
import vue from 'vue';
import vueapp from '~/src/custom/vue/apps/filter-listing/index';
import app from '~/src/custom/vue/apps/filter-listing/app.vue';

// connect vue component and init app
vue.component('app', app);
vueapp.$mount('#filter-app');